/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:client-mgt-pilet:list-clients */

export interface ListClientsBlockParams {
	/**
	 * CSS padding shorthand accepted
	 */
	padding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:view-client */

export interface ViewClientBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	padding?: string;
}
/** Zone parameters for urn:zone:client-mgt-pilet:view-client:tab */

export interface ViewClientTabZoneParams {
	label: {
		de?: string;
		en?: string;
		es?: string;
		fr?: string;
		it?: string;
		ja?: string;
		nl?: string;
		'pt-BR'?: string;
	};
	testId?: string;
}
/** Contract Data for urn:zone:client-mgt-pilet:view-client:tab */

export interface ViewClientTabContractData {
	firstPrimaryContactRID?: string;
	userRIDs?: string[];
}
/** Zone parameters for urn:zone:client-mgt-pilet:view-client:overview:widget */

export interface ViewClientOverviewWidgetZoneParams {
	xs?: {
		offset?: number;
		pull?: number;
		push?: number;
		span?: number;
	};
	sm?: {
		offset?: number;
		pull?: number;
		push?: number;
		span?: number;
	};
	md?: {
		offset?: number;
		pull?: number;
		push?: number;
		span?: number;
	};
	lg?: {
		offset?: number;
		pull?: number;
		push?: number;
		span?: number;
	};
	xl?: {
		offset?: number;
		pull?: number;
		push?: number;
		span?: number;
	};
	xxl?: {
		offset?: number;
		pull?: number;
		push?: number;
		span?: number;
	};
}
/** Zone parameters for urn:zone:client-mgt-pilet:view-client:create:option */

export interface ViewClientCreateOptionZoneParams {
	testId?: string;
	label: Label;
	/**
	 * The kind of extension that will handle the option selection. All handlers are called with the following properties { clientRID: string; canAddPrimaryServiceContacts: boolean; primaryClientContactRIDs: string[]; primaryServiceContactRIDs: string[] }. "menu" will trigger a sub menu with more options from the "options" property.
	 */
	handleWith: 'drawer' | 'modal' | 'menu';
	extensionHandlerName: string;
	titleForHandler?: TitleForHandler;
	overlayOptions?: OverlayOptions;
	onCompleteInteraction?: OnCompleteInteraction;
	/**
	 * Category section for the dropdown menu items
	 */
	section?: 'people' | 'services';
	options?: {
		testId?: string;
		label: Label;
		/**
		 * The kind of extension that will handle the option selection. All handlers are called with the following properties { clientRID: string; canAddPrimaryServiceContacts: boolean; primaryClientContactRIDs: string[]; primaryServiceContactRIDs: string[] }. "menu" will trigger a sub menu with more options from the "options" property.
		 */
		handleWith: 'drawer' | 'modal' | 'menu';
		extensionHandlerName: string;
		titleForHandler?: TitleForHandler;
		overlayOptions?: OverlayOptions;
		onCompleteInteraction?: OnCompleteInteraction;
	}[];
}

/** Zone parameters for urn:zone:client-mgt-pilet:client-list:context-bar:action */

export interface ViewClientListContextBarActionZoneParams {
	testId?: string;
	iconName?: string;
	requiredEntitlement?: string;
	label: Label;
	/**
	 * The kind of extension that will handle the option selection. All handlers are called with the following properties { clientRID: string; primaryClientContactRIDs: string[]; primaryServiceContactRIDs: string[] }.
	 */
	handleWith: 'drawer' | 'modal';
	extensionHandlerName: string;
	titleForHandler?: TitleForHandler;
	overlayOptions?: OverlayOptions;
	onCompleteInteraction?: OnCompleteInteraction;
}

export interface Label {
	de?: string;
	en?: string;
	es?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
export interface TitleForHandler {
	de?: string;
	en?: string;
	es?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
/**
 * Additional options as defined by the modal or drawer options
 */
export interface OverlayOptions {}
export interface OnCompleteInteraction {
	eventName: string;
	/**
	 * Describe the payload that should be emitted with the event. Can use the payload from the drawer interaction as a template source with {{data}}.
	 */
	eventPayload?: {
		[k: string]: unknown;
	};
}
/** Contract Data for urn:zone:client-mgt-pilet:view-client:create:option */

export interface ViewClientCreateOptionContractData {
	firstPrimaryContactRID?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:client-intake */

export interface ClientIntakeBlockParams {
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
	/**
	 * The starting actor RID for primary contact
	 */
	initialActorRID?: string;
	/**
	 * Disable redirection to the newly created client
	 */
	disableRedirect?: boolean;
}
/** Block parameters for urn:block:client-mgt-pilet:client-contact-intake */

export interface ClientContactIntakeBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}

/** Block parameters for urn:block:client-mgt-pilet:client-contact-update */
export interface ClientContactUpdateBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * Client contact RID
	 * /
	 * Client contact RID
	 */
	clientContactRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}

/** Block parameters for urn:block:client-mgt-pilet:client-update */

export interface ClientUpdateBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:client-requests */

export interface ClientRequestsBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * Parent containerRID under which to look for client requests. Default value is accountRID
	 */
	containerRID?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:contacts-table */

export interface ContactsTableBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:client-contacts-widget */

export interface ClientContactsWidgetBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:service-contacts-widget */

export interface ServiceContactsWidgetBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:client-details-widget */

export interface ClientDetailsWidgetBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:client-associate-resources-tag-renderer */

export interface ClientAssociateResourcesTagRendererBlockParams {
	/**
	 * RID of the resource which needs to be associated with client
	 */
	subjectRID: string;
	/**
	 * Title of the drawer
	 */
	drawerTitle?: string;
	/**
	 * Users associated with subjectRID for computing client suggestion
	 */
	userRIDs?: string[];
}
/** Block parameters for urn:block:client-mgt-pilet:suggested-contacts-widget */

export interface SuggestedContactsWidgetBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:suggested-clients */

export interface SuggestedClientsBlockParams {
	currentClientRID?: string;
	userRIDs?: string[];
	/**
	 * CSS padding shorthand accepted
	 */
	contentPadding?: string;
	widgetType?: 'card' | 'inline-block';
}
/** Block parameters for urn:block:client-mgt-pilet:client-requests-widget */

export interface ClientRequestsWidgetBlockParams {
	/**
	 * Client RID
	 */
	clientRID: string;
	/**
	 * Parent containerRID under which to look for client requests. Default value is accountRID
	 */
	containerRID?: string;
	/**
	 * CSS padding shorthand accepted
	 */
	padding?: string;
}
/** Block parameters for urn:block:client-mgt-pilet:clients-data-provider */

export interface ClientsDataProviderBlockParams {
	/**
	 * Describe if you want to get clients by membership in the client contact group or service team group.
	 */
	membershipType?: 'client_contact' | 'service_teammember';
}
/** Zone parameters for urn:zone:client-mgt-pilet:clients-data-provider:children */

export interface ClientsDataProviderChildrenZoneParams {}
/** Contract Data for urn:zone:client-mgt-pilet:clients-data-provider:children */

export type ServiceTeamMember = Contact;

export interface ClientsDataProviderChildrenContractData {
	clients?: Client[];
}
export interface Client {
	/**
	 * The Resource ID of the client entity.
	 */
	rid: string;
	/**
	 * The client entities internal name that is used by the service provider.
	 */
	internalName?: string;
	/**
	 * An external name that conforms to the individual or company.
	 */
	externalName?: string;
	/**
	 * A unique identifier that was entered by the service provider.
	 */
	uniqueClientId?: string;
	/**
	 * The description of metadata that is included for this client entity.
	 */
	metadataName?: string;
	metadata?: ClientMetadata;
	/**
	 * The service team for the client entity. This is generally only available to the service team.
	 */
	serviceTeam?: ServiceTeamMember[];
	/**
	 * A list of contacts that are part of the client entity. This is generally only available to the service team and primary client contacts.
	 */
	contacts?: Contact[];
}
/**
 * Metadata object that conforms to a specific schema
 */
export interface ClientMetadata {}
export interface Contact {
	actorRID: string;
	metadataName?: string;
	metadata?: ClientMetadata;
	/**
	 * Email address of the contact
	 */
	email?: string;
	firstName?: string;
	lastName?: string;
	telephone?: string;
}

export namespace BlockNames {
	export const ListClients = 'urn:block:client-mgt-pilet:list-clients' as const;
	export type ListClients = 'urn:block:client-mgt-pilet:list-clients';
	export const ViewClient = 'urn:block:client-mgt-pilet:view-client' as const;
	export type ViewClient = 'urn:block:client-mgt-pilet:view-client';
	export const ClientIntake = 'urn:block:client-mgt-pilet:client-intake' as const;
	export type ClientIntake = 'urn:block:client-mgt-pilet:client-intake';
	export const ClientContactIntake =
		'urn:block:client-mgt-pilet:client-contact-intake' as const;
	export type ClientContactIntake = 'urn:block:client-mgt-pilet:client-contact-intake';
	export const ClientContactUpdate =
		'urn:block:client-mgt-pilet:client-contact-update' as const;
	export type ClientContactUpdate = 'urn:block:client-mgt-pilet:client-contact-update';
	export const ClientUpdate = 'urn:block:client-mgt-pilet:client-update' as const;
	export type ClientUpdate = 'urn:block:client-mgt-pilet:client-update';
	export const ClientRequests = 'urn:block:client-mgt-pilet:client-requests' as const;
	export type ClientRequests = 'urn:block:client-mgt-pilet:client-requests';
	export const ContactsTable = 'urn:block:client-mgt-pilet:contacts-table' as const;
	export type ContactsTable = 'urn:block:client-mgt-pilet:contacts-table';
	export const ClientContactsWidget =
		'urn:block:client-mgt-pilet:client-contacts-widget' as const;
	export type ClientContactsWidget = 'urn:block:client-mgt-pilet:client-contacts-widget';
	export const ServiceContactsWidget =
		'urn:block:client-mgt-pilet:service-contacts-widget' as const;
	export type ServiceContactsWidget =
		'urn:block:client-mgt-pilet:service-contacts-widget';
	export const ClientDetailsWidget =
		'urn:block:client-mgt-pilet:client-details-widget' as const;
	export type ClientDetailsWidget = 'urn:block:client-mgt-pilet:client-details-widget';
	export const ClientAssociateResourcesTagRenderer =
		'urn:block:client-mgt-pilet:client-associate-resources-tag-renderer' as const;
	export type ClientAssociateResourcesTagRenderer =
		'urn:block:client-mgt-pilet:client-associate-resources-tag-renderer';
	export const SuggestedContactsWidget =
		'urn:block:client-mgt-pilet:suggested-contacts-widget' as const;
	export type SuggestedContactsWidget =
		'urn:block:client-mgt-pilet:suggested-contacts-widget';
	export const SuggestedClients = 'urn:block:client-mgt-pilet:suggested-clients' as const;
	export type SuggestedClients = 'urn:block:client-mgt-pilet:suggested-clients';
	export const ClientRequestsWidget =
		'urn:block:client-mgt-pilet:client-requests-widget' as const;
	export type ClientRequestsWidget = 'urn:block:client-mgt-pilet:client-requests-widget';
	export const ClientsDataProvider =
		'urn:block:client-mgt-pilet:clients-data-provider' as const;
	export type ClientsDataProvider = 'urn:block:client-mgt-pilet:clients-data-provider';
}

export namespace ZoneTypes {
	export const ViewClientTab = 'urn:zone:client-mgt-pilet:view-client:tab' as const;
	export type ViewClientTab = 'urn:zone:client-mgt-pilet:view-client:tab';
	export const ViewClientOverviewWidget =
		'urn:zone:client-mgt-pilet:view-client:overview:widget' as const;
	export type ViewClientOverviewWidget =
		'urn:zone:client-mgt-pilet:view-client:overview:widget';
	export const ViewClientCreateOption =
		'urn:zone:client-mgt-pilet:view-client:create:option' as const;
	export type ViewClientCreateOption =
		'urn:zone:client-mgt-pilet:view-client:create:option';
	export const ClientsDataProviderChildren =
		'urn:zone:client-mgt-pilet:clients-data-provider:children' as const;
	export type ClientsDataProviderChildren =
		'urn:zone:client-mgt-pilet:clients-data-provider:children';
	export const ViewClientListContextBarActionZoneParams =
		'urn:zone:client-mgt-pilet:client-list:context-bar:action' as const;
	export type ViewClientListContextBarActionZoneParams =
		'urn:zone:client-mgt-pilet:client-list:context-bar:action';
}

export type ListClientsProps = ShellProps & BlockParams & ListClientsBlockParams;
export type ViewClientProps = ShellProps & BlockParams & ViewClientBlockParams;
export type ClientIntakeProps = ShellProps & BlockParams & ClientIntakeBlockParams;
export type ClientContactIntakeProps = ShellProps &
	BlockParams &
	ClientContactIntakeBlockParams;
export type ClientContactUpdateProps = ShellProps &
	BlockParams &
	ClientContactIntakeBlockParams;
export type ClientUpdateProps = ShellProps & BlockParams & ClientUpdateBlockParams;
export type ClientRequestsProps = ShellProps & BlockParams & ClientRequestsBlockParams;
export type ContactsTableProps = ShellProps & BlockParams & ContactsTableBlockParams;
export type ClientContactsWidgetProps = ShellProps &
	BlockParams &
	ClientContactsWidgetBlockParams;
export type ServiceContactsWidgetProps = ShellProps &
	BlockParams &
	ServiceContactsWidgetBlockParams;
export type ClientDetailsWidgetProps = ShellProps &
	BlockParams &
	ClientDetailsWidgetBlockParams;
export type ClientAssociateResourcesTagRendererProps = ShellProps &
	BlockParams &
	ClientAssociateResourcesTagRendererBlockParams;
export type SuggestedContactsWidgetProps = ShellProps &
	BlockParams &
	SuggestedContactsWidgetBlockParams;
export type SuggestedClientsProps = ShellProps &
	BlockParams &
	SuggestedClientsBlockParams;
export type ClientRequestsWidgetProps = ShellProps &
	BlockParams &
	ClientRequestsWidgetBlockParams;
export type ClientsDataProviderProps = ShellProps &
	BlockParams &
	ClientsDataProviderBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:client-mgt-pilet:list-clients']: BlockParams & ListClientsBlockParams;
		['urn:block:client-mgt-pilet:view-client']: BlockParams & ViewClientBlockParams;
		['urn:block:client-mgt-pilet:client-intake']: BlockParams & ClientIntakeBlockParams;
		['urn:block:client-mgt-pilet:client-contact-intake']: BlockParams &
			ClientContactIntakeBlockParams;
		['urn:block:client-mgt-pilet:client-contact-update']: BlockParams &
			ClientContactUpdateBlockParams;
		['urn:block:client-mgt-pilet:client-update']: BlockParams & ClientUpdateBlockParams;
		['urn:block:client-mgt-pilet:client-requests']: BlockParams &
			ClientRequestsBlockParams;
		['urn:block:client-mgt-pilet:contacts-table']: BlockParams & ContactsTableBlockParams;
		['urn:block:client-mgt-pilet:client-contacts-widget']: BlockParams &
			ClientContactsWidgetBlockParams;
		['urn:block:client-mgt-pilet:service-contacts-widget']: BlockParams &
			ServiceContactsWidgetBlockParams;
		['urn:block:client-mgt-pilet:client-details-widget']: BlockParams &
			ClientDetailsWidgetBlockParams;
		['urn:block:client-mgt-pilet:client-associate-resources-tag-renderer']: BlockParams &
			ClientAssociateResourcesTagRendererBlockParams;
		['urn:block:client-mgt-pilet:suggested-contacts-widget']: BlockParams &
			SuggestedContactsWidgetBlockParams;
		['urn:block:client-mgt-pilet:suggested-clients']: BlockParams &
			SuggestedClientsBlockParams;
		['urn:block:client-mgt-pilet:client-requests-widget']: BlockParams &
			ClientRequestsWidgetBlockParams;
		['urn:block:client-mgt-pilet:clients-data-provider']: BlockParams &
			ClientsDataProviderBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:client-mgt-pilet:view-client:tab']: ViewClientTabZoneParams;
		['urn:zone:client-mgt-pilet:view-client:overview:widget']: ViewClientOverviewWidgetZoneParams;
		['urn:zone:client-mgt-pilet:view-client:create:option']: ViewClientCreateOptionZoneParams;
		['urn:zone:client-mgt-pilet:clients-data-provider:children']: ClientsDataProviderChildrenZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:client-mgt-pilet:view-client:tab']: ViewClientTabContractData;
		['urn:zone:client-mgt-pilet:view-client:overview:widget']: never;
		['urn:zone:client-mgt-pilet:view-client:create:option']: ViewClientCreateOptionContractData;
		['urn:zone:client-mgt-pilet:clients-data-provider:children']: ClientsDataProviderChildrenContractData;
	}
}
